export default ".unavailable {\n  visibility: hidden;\n  display: none;\n}";